// extracted by mini-css-extract-plugin
export default {"wrapper":"Favorites_wrapper__HfvUS","noFavorites":"Favorites_noFavorites__QWany"};